// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "saved_view.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "saved_view.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class SavedView$Type extends MessageType {
    constructor() {
        super("SavedView", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "saved_view_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "filters", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_private", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "created_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.savedViewTypeId = 0;
        message.name = "";
        message.filters = "";
        message.isPrivate = 0;
        message.createdByUserId = 0;
        message.isActive = 0;
        message.dateCreated = "";
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 saved_view_type_id */ 2:
                    message.savedViewTypeId = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string filters */ 4:
                    message.filters = reader.string();
                    break;
                case /* int32 is_private */ 5:
                    message.isPrivate = reader.int32();
                    break;
                case /* int32 created_by_user_id */ 6:
                    message.createdByUserId = reader.int32();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                case /* string date_created */ 8:
                    message.dateCreated = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 10:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 11:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 saved_view_type_id = 2; */
        if (message.savedViewTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.savedViewTypeId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string filters = 4; */
        if (message.filters !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.filters);
        /* int32 is_private = 5; */
        if (message.isPrivate !== 0)
            writer.tag(5, WireType.Varint).int32(message.isPrivate);
        /* int32 created_by_user_id = 6; */
        if (message.createdByUserId !== 0)
            writer.tag(6, WireType.Varint).int32(message.createdByUserId);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        /* string date_created = 8; */
        if (message.dateCreated !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dateCreated);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 10; */
        if (message.orderBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 11; */
        if (message.orderDir !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SavedView
 */
export const SavedView = new SavedView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedViewList$Type extends MessageType {
    constructor() {
        super("SavedViewList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SavedView },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SavedView results */ 1:
                    message.results.push(SavedView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SavedView results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SavedView.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SavedViewList
 */
export const SavedViewList = new SavedViewList$Type();
/**
 * @generated ServiceType for protobuf service SavedViewService
 */
export const SavedViewService = new ServiceType("SavedViewService", [
    { name: "Create", options: {}, I: SavedView, O: SavedView },
    { name: "Get", options: {}, I: SavedView, O: SavedView },
    { name: "BatchGet", options: {}, I: SavedView, O: SavedViewList },
    { name: "Update", options: {}, I: SavedView, O: SavedView },
    { name: "Delete", options: {}, I: SavedView, O: Empty }
]);
